export default __webpack_public_path__ + "static/media/batch-retrieval.58eaf300.svg";